var _path, _rect, _rect2, _circle, _rect3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgMicPermissionNeededIconinline = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 34,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.25 15.017V7.083A4.244 4.244 0 0017 2.833a4.22 4.22 0 00-4.193 3.754l8.443 8.43zm4.363.566c-.58 0-1.09.425-1.175 1.006-.071.454-.17.907-.312 1.318l1.799 1.799c.425-.85.737-1.771.892-2.748a1.214 1.214 0 00-1.204-1.375zM5.256 5.043a1.41 1.41 0 000 1.998l7.494 7.508v.61c0 1.685.85 3.286 2.31 4.122 1.062.609 1.997.623 2.86.439l2.352 2.352a7.79 7.79 0 01-3.272.736c-3.598 0-6.913-2.507-7.438-6.219a1.188 1.188 0 00-1.175-1.006c-.737 0-1.304.652-1.205 1.374.652 4.194 4.194 7.509 8.401 8.146v3.23c0 .78.638 1.417 1.417 1.417a1.42 1.42 0 001.417-1.417v-3.23a10.1 10.1 0 003.612-1.275l4.944 4.945a1.41 1.41 0 001.998 0 1.41 1.41 0 000-1.998L7.253 5.043a1.41 1.41 0 00-1.997 0z",
    fill: "#9AA3B3"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 19,
    y: 19,
    width: 11,
    height: 11,
    rx: 2,
    fill: "#E9BE25"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 19,
    y: 19,
    width: 11,
    height: 11,
    rx: 2,
    stroke: "#fff"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 24.706,
    cy: 27.529,
    r: 1,
    fill: "#fff"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 23.706,
    y: 20.882,
    width: 2,
    height: 5,
    rx: 1,
    fill: "#fff"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgMicPermissionNeededIconinline);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/mic-permission-needed-icon.inline.0838c2d905f977c13b98ea48c08b3bde.svg";